import { useNavigate } from 'react-router';
import { shouldNavigateToUploadKyc } from '@/pages/UploadKYC/useUploadKYC';
import * as R from '@/Router/routes';

import { Application } from '@/api/getClientApplication';

function useNavigateWithTopUpResolution() {
  const navigate = useNavigate();
  const navigateWithTopUpResolution = (application: Application): void => {
    if (application.resolution === 'REJECTED') {
      navigate(R.ADDITIONAL_AMOUNT_REJECT, {
        state: { backUrl: R.TOP_UP_AMOUNT },
      });
      return;
    }

    // NOTE: Check if client is required to upload ID Documents
    if (shouldNavigateToUploadKyc(application)) {
      navigate(R.KYC_ADDITIONAL_UPLOAD);
      return;
    }

    // default redirect
    navigate(R.ADDITIONAL_AMOUNT_APPROVED, {
      state: { backUrl: R.TOP_UP_AMOUNT },
    });
  };

  return { navigateWithTopUpResolution };
}

export default useNavigateWithTopUpResolution;
